import { apiGet, apiPost, apiPostWithMultiPart, apiPatch } from "../utils/axios";
import { domainUrl } from "../utils/domainUrls";

export default {
    saveRecording: (payload) => apiPostWithMultiPart(domainUrl(`/v1/recording/save-recording`), payload),
    getRecording: (scriptId) => apiGet(domainUrl(`/v1/recording/${scriptId}`)),
    getMyVoiceRecording: (pageSize=10, currentPage=1, searchInput="", statusFilter="") => apiGet(domainUrl(`/v1/recording/my-voices?limit=${pageSize}&page=${currentPage}&name=${searchInput}&status=${statusFilter}`)),
    getRecordingFileFromS3: (payload) => apiPost(domainUrl(`/v1/recording/file`), payload),
    assignRecording: (payload) => apiPatch(domainUrl(`/v1/recording/assign-library-manager`), payload),
    recordingApproveOrReject: (id, payload) => apiPatch(domainUrl(`/v1/recording/${id}/approve-or-reject`), payload),

    deleteRecording: (payload) => apiPost(domainUrl(`/v1/recording/delete`),payload),

    uploadClonnedVoice: (payload) => apiPostWithMultiPart(domainUrl(`/v1/recording/upload-clonned-voice`), payload),

}